import './machine.css';

import { Components } from '@ionic/core';
import { IonLabel, IonText } from '@ionic/react';
import { CSSProperties, ReactElement } from 'react';
import {
  GoFile,
  GoFileBinary,
  GoFileCode,
  GoFileDirectory,
  GoFileZip,
} from 'react-icons/go';
import { IconType } from 'react-icons/lib';
import { useRouteMatch } from 'react-router';
import { File } from '../../api/graphql/generated';
import { formatDate } from '../../util/date-utils';
import { FileType, formatFileSize, getFileType } from '../../util/file-utils';
import { IonItem } from '../ionic/IonItem';

interface MachineFileItemProps {
  item?: File;
  pendingAction?: boolean;
  onPress?: () => void;
  ionItemProps?: Partial<Components.IonItem> & { style?: CSSProperties };
  rightElement?: ReactElement;
}

const MachineFileItem = (props: MachineFileItemProps): ReactElement => {
  const { item, ionItemProps, onPress, rightElement } = props;

  const { url } = useRouteMatch();

  const dateModified = item?.updatedAt ? formatDate(item.updatedAt) : undefined;
  let size: string | undefined;
  let subtitle: string | ReactElement | undefined = dateModified;
  if (item?.size) {
    size = formatFileSize(item.size);
    subtitle = `${size}, ${subtitle}`;
  }

  let Icon = GoFileDirectory;
  if (item?.type === 'file') {
    Icon = getOcticonForExtension(item?.name);
  }

  let link: string | undefined = undefined;
  if (item?.path) {
    const itemPath = `${url}/${item.id.substring(0, 3)}`;
    if (item.type === 'dir') {
      link = `${itemPath}?path=${encodeURIComponent(item?.path)}`;
    } else {
      link = `${itemPath}/versions?path=${encodeURIComponent(item?.path)}`;
    }
  }

  return (
    <IonItem
      className="ion-no-padding file-item"
      routerLink={onPress ? undefined : link}
      routerDirection="forward"
      onClick={onPress}
      {...ionItemProps}
    >
      <IonText color="medium">
        <Icon className="file-icon" size={20} />
      </IonText>
      <IonLabel>
        <h2>{item?.name}</h2>
        <p>{subtitle}</p>
      </IonLabel>
      {rightElement}
    </IonItem>
  );
};

const getOcticonForExtension = (file: string | undefined): IconType => {
  const extension = getFileType(file);
  switch (extension) {
    case FileType.ARCHIVE:
      return GoFileZip;
    case FileType.PROGRAM:
      return GoFileCode;
    case FileType.SCRIPT:
      return GoFileCode;
    case FileType.INSTALLATION:
      return GoFileBinary;
    case FileType.BACKUP:
      return GoFile;
    default:
      return GoFile;
  }
};

export { MachineFileItem };
